import * as ng from 'angular';
import { BaseUrlService } from '../../services/base-url.service';
import { ArchiSmallServices } from '../../services/archismall.service';
import { rabbitMQ } from '../../third/rabbitMQ';

class UnsubscriptionController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        '$state',
        '$http',
        'configuration',
        'ArchiSmallServices',
        'store',
        'BaseUrlService'
    ];
    constructor(
        private $scope: any,
        private $rootScope: any,
        private $state: ng.ui.IStateService,
        private $http: ng.IHttpService,
        private configuration: any,
        private ArchiSmallServices: ArchiSmallServices,
        private store: ng.a0.storage.IStoreService,
        private _baseService: BaseUrlService
    ) {
        $scope.tooltips = {
            'help': 'Ti serve Aiuto? Leggi il Manuale o apri un\nticket e verrai contattato dal Servizio Assistenza.',
            'notifications': 'ArchiSMALL ti tiene aggiornato sulle operazioni eseguite.\nClicca sulle singole notifiche per consultarle.'
        };

        ArchiSmallServices.getUser($rootScope.currentUser().sub)
            .then((response: any) => {
                $rootScope.user = response;
                store.set('user', response);

                ArchiSmallServices.rabbitMQConfig()
                    .then((response: any) => {
                        rabbitMQ.init(response.user, response.password, configuration.testEnvironment);
                        $rootScope.startNotificationWorker();
                    }, (error) => {
                        $rootScope.alert('error', error);
                    });
                // rimuovere ArchiSmallServices.setBaseUrl(response.accountData.serverInstance);
                // rimuovere _baseService.setBaseUrl(response.accountData.serverInstance);
            }, (error) => {
                $rootScope.alert('error', error);
            });
        $scope.closeAlert = (index) => {
            store.set('showAlert', false);
        };

        $scope.getNotificationClass = (item) => {
            return {
                'icon-icon_scarica': item.type === 'archidrive' || item.type === 'archidrive-multiple',
                'icon-icon_consulta': item.type === 'conservato',
                'icon-icon_conserva': item.type === 'conservazione' || item.type === 'conservazione-fatture-attive'
                    || item.type === 'conservazione-fatture-attive-versamento' || item.type === 'conservazione-fatture-pa-e-notifiche'
                    || item.type === 'conservazione-fatture-attive-enabled' || item.type === 'conservazione-pec'
                    || item.type === 'conservazione-pec-versamento' || item.type === 'conservazione-fattura-gse-e-notifiche'
                    || item.type === 'conservazione-fatture-elettronica-passiva',
                'icon-icon_fattura': item.type === 'fattura-pa-status' || item.type === 'fattura-pr-status' || item.type === 'fattura-passiva-status'
            };
        };
    }
}

export const UnsubscriptionComponent: ng.IComponentOptions = {
    template: require('./unsubscription.html'),
    controller: UnsubscriptionController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/unsubscription/unsubscription.ts